<template>
  <div class="text-center">
    <TbWordLogo class="inline-flex max-w-[12rem] pb-12" />
    <div class="pb-12">
      <img
        src="./assets/expired.svg"
        alt="expired link image"
        class="inline-flex"
      >
    </div>
    <div>
      <div class="text-2xl text-primary font-bold pb-3">
        Sorry, your link has expired.
      </div>
      <div class="pb-6">
        <div>
          It looks like your invite to Elective is invalid. Please reach out to your admin for a new invitation.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TbWordLogo } from '@/components/tasty_bistro';
</script>
